import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import Modal from "react-bootstrap/Modal";
import { AnchorComponent, ButtonComponent } from "../../elements";
import { Button, Pagination, Form } from "react-bootstrap";

export default function CheckerProductsTableComponent({
    thead,
    tbody,
    activeTab,
    selectedProductIds = [],
    setSelectedProductIds,
    onReceiveSingle,
}) {
    const { t } = useContext(TranslatorContext);

    const [alertModal, setAlertModal] = useState(false);
    const [data, setData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);

    useEffect(() => {
        setData(tbody || []);
        setCurrentPage(1);
    }, [tbody]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage) || 1;

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = data.map((item) => item.id);
            setSelectedProductIds(allIds);
        } else {
            setSelectedProductIds([]);
        }
    };

    const handleSelectOne = (id) => {
        if (selectedProductIds.includes(id)) {
            setSelectedProductIds(selectedProductIds.filter((item) => item !== id));
        } else {
            setSelectedProductIds([...selectedProductIds, id]);
        }
    };

    const renderPaginationItems = () => {
        if (totalPages <= 7) {
            return [...Array(totalPages)].map((_, idx) => (
                <Pagination.Item
                    key={idx + 1}
                    active={idx + 1 === currentPage}
                    onClick={() => setCurrentPage(idx + 1)}
                >
                    {idx + 1}
                </Pagination.Item>
            ));
        }

        if (currentPage <= 4) {
            return (
                <>
                    {[1, 2, 3, 4, 5].map((page) => (
                        <Pagination.Item
                            key={page}
                            active={page === currentPage}
                            onClick={() => setCurrentPage(page)}
                        >
                            {page}
                        </Pagination.Item>
                    ))}
                    <Pagination.Ellipsis disabled />
                    <Pagination.Item onClick={() => setCurrentPage(totalPages)}>
                        {totalPages}
                    </Pagination.Item>
                </>
            );
        }

        if (currentPage >= totalPages - 3) {
            return (
                <>
                    <Pagination.Item onClick={() => setCurrentPage(1)}>1</Pagination.Item>
                    <Pagination.Ellipsis disabled />
                    {[totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages].map((page) => (
                        <Pagination.Item
                            key={page}
                            active={page === currentPage}
                            onClick={() => setCurrentPage(page)}
                        >
                            {page}
                        </Pagination.Item>
                    ))}
                </>
            );
        }

        return (
            <>
                <Pagination.Item onClick={() => setCurrentPage(1)}>1</Pagination.Item>
                <Pagination.Ellipsis disabled />
                {[currentPage - 1, currentPage, currentPage + 1].map((page) => (
                    <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => setCurrentPage(page)}
                    >
                        {page}
                    </Pagination.Item>
                ))}
                <Pagination.Ellipsis disabled />
                <Pagination.Item onClick={() => setCurrentPage(totalPages)}>
                    {totalPages}
                </Pagination.Item>
            </>
        );
    };

    return (
        <div>
            <div className="mc-table-responsive" style={{ overflowX: "auto", width: "100%" }}>
                <table className="mc-table product" style={{ width: "100%", minWidth: "900px" }}>
                    <thead className="mc-table-head primary">
                        <tr>
                            {activeTab === "new" && (
                                <th style={{ width: "40px" }}>
                                    <input
                                        type="checkbox"
                                        onChange={handleSelectAll}
                                        checked={data.length > 0 && selectedProductIds.length === data.length}
                                    />
                                </th>
                            )}
                            {thead?.map((item, index) => {
                                if (item === "Select") return null;
                                const isProductCol =
                                    item?.toLowerCase()?.includes("product") ||
                                    item?.toLowerCase()?.includes("title");
                                return (
                                    <th
                                        key={index}
                                        style={isProductCol ? { minWidth: "300px" } : {}}
                                    >
                                        {t(item)}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {currentItems && currentItems.length > 0 ? (
                            currentItems.map((item, index) => {
                                const pImage = item?.card_img
                                    ? `${process.env.REACT_APP_IMG_URL}${item.card_img}`
                                    : "";
                                const pTitle = item?.title || "N/A";
                                const pDescribe = item?.selling_style || "N/A";
                                const pCode = item?.product_code || "N/A";
                                const style = item?.selling_style || "N/A";
                                const pQty = item?.product_qty ?? 0;

                                const pCategory =
                                    typeof item?.category === "object"
                                        ? item?.category?.name
                                        : item?.category || "N/A";

                                const pBrand =
                                    typeof item?.brand === "object"
                                        ? item?.brand?.name || item?.brand?.title
                                        : item?.brand || "N/A";

                                const pricePrev =
                                    typeof item?.price === "object" ? item?.price?.previous : null;
                                const pricePresent =
                                    typeof item?.sell_price_dollar === "object"
                                        ? item?.sell_price_dollar?.present
                                        : item?.sell_price_dollar || 0;
                                const auctionMinPrice = item?.pricing?.auction_min_price ?? item?.auction_min_price;

                                const iconDetail = "info";
                                const iconView = "visibility";
                                const iconEdit = "edit";
                                const isSelected = selectedProductIds.includes(item?.id);

                                return (
                                    <tr key={item?.id || index}>
                                        {activeTab === "new" && (
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={isSelected}
                                                    onChange={() => handleSelectOne(item.id)}
                                                />
                                            </td>
                                        )}

                                        {activeTab === "overall_checked" && (
                                            <td className="align-middle" style={{ width: "230px", minWidth: "230px" }}>
                                                <div className="d-flex flex-column gap-1" style={{ fontSize: "12px", wordBreak: "break-word" }}>
                                                    {item.checked_date && (
                                                        <div>
                                                            <strong>Checked Date:</strong>
                                                            <br />
                                                            {item.checked_date}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        )}

                                        <td>
                                            <div className="mc-table-check">{pCode}</div>
                                        </td>

                                        <td style={{ minWidth: "300px", maxWidth: "400px" }}>
                                            <div className="mc-table-product md" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                {pImage && (
                                                    <img
                                                        src={pImage}
                                                        alt={pTitle}
                                                        style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "6px" }}
                                                    />
                                                )}
                                                <div className="mc-table-group" style={{ overflow: "hidden" }}>
                                                    <h6 style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>{pTitle}</h6>
                                                    <p className="mb-0 text-muted small">{pDescribe}</p>
                                                    <p className="mb-0 text-muted small">
                                                        {pCategory} | {pBrand}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>

                                        {activeTab === "rejected" && (
                                            <td className="align-middle" style={{ width: "220px", minWidth: "200px" }}>
                                                <div className="d-flex flex-column gap-1" style={{ fontSize: "12px", wordBreak: "break-word" }}>
                                                    <span className="badge bg-danger-subtle text-danger p-1 text-wrap text-start">
                                                        {item?.reject_reason?.reason || item?.reason || "N/A"}
                                                    </span>
                                                </div>
                                            </td>
                                        )}

                                        <td>
                                            <div className="mc-table-price">
                                                {pricePrev && <del>{pricePrev}</del>}
                                                <p className="mb-0">${pricePresent}</p>
                                                {style}
                                                {style === "Auction" && auctionMinPrice !== null && auctionMinPrice !== undefined && auctionMinPrice !== "" && (
                                                    <p className="mb-0 small text-muted">
                                                        <strong>{t("Auction")}:</strong> ${auctionMinPrice}
                                                    </p>
                                                )}
                                            </div>
                                        </td>

                                        <td>{pQty}</td>

                                        <td>
                                            <div className="mc-table-action" style={{ gap: "8px", display: "flex", alignItems: "center" }}>
                                                <AnchorComponent
                                                    to={`/checker-products-view/${item?.id || ""}`}
                                                    state={{ item }}
                                                    title="Detail"
                                                    className="material-icons detail"
                                                    style={{ color: "#3b82f6", backgroundColor: "#eff6ff" }}
                                                >
                                                    {iconDetail}
                                                </AnchorComponent>

                                                <a
                                                    href={`${process.env.REACT_APP_ECOM_URL}${item?.id || ""}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="View Store Product"
                                                    className="material-icons view"
                                                    style={{ textDecoration: "none" }}
                                                >
                                                    {iconView}
                                                </a>

                                                {activeTab === "new" && (
                                                    <Button
                                                        type="button"
                                                        variant="success"
                                                        size="sm"
                                                        onClick={() => onReceiveSingle && onReceiveSingle(item.id)}
                                                        className="d-inline-flex align-items-center justify-content-center text-white border-0"
                                                        style={{
                                                            height: "30px",
                                                            padding: "0 12px",
                                                            fontSize: "11px",
                                                            fontWeight: "600",
                                                            borderRadius: "6px",
                                                            backgroundColor: "#198754",
                                                            textTransform: "uppercase",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        Receive
                                                    </Button>
                                                )}

                                                {activeTab === "recieved" && (
                                                    <AnchorComponent
                                                        to={`/checker-products-edit/${item.id}`} // Pass item.id here
                                                        state={{ item }}
                                                        title="Edit"
                                                        className="material-icons edit"
                                                    >
                                                        {iconEdit}
                                                    </AnchorComponent>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={thead?.length ? thead.length + (activeTab === "new" ? 1 : 0) : 8} className="text-center py-4">
                                    {t("no_products_found")}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {data.length > 0 && (
                <div className="d-flex flex-wrap justify-content-between align-items-center mt-4 px-2 gap-3">
                    <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 flex-wrap">
                        <span className="text-muted small">{t("Rows per page")}:</span>
                        <Form.Select
                            size="sm"
                            value={itemsPerPage}
                            onChange={(e) => {
                                setItemsPerPage(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                            style={{ width: "80px" }}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </Form.Select>
                        <span className="text-muted small ms-2">
                            Showing {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, data.length)} of {data.length} items
                        </span>
                    </div>

                    <Pagination className="mb-0 flex-wrap">
                        <Pagination.First
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(1)}
                        />
                        <Pagination.Prev
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        />

                        {renderPaginationItems()}

                        <Pagination.Next
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        />
                        <Pagination.Last
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(totalPages)}
                        />
                    </Pagination>
                </div>
            )}

            <Modal show={alertModal} onHide={() => setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>{t("are_you_sure")}</h3>
                    <p>{t("want_to_delete_this_product")}</p>
                    <Modal.Footer>
                        <ButtonComponent
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setAlertModal(false)}
                        >
                            {t("close")}
                        </ButtonComponent>
                        <ButtonComponent
                            type="button"
                            className="btn btn-danger"
                            onClick={() => setAlertModal(false)}
                        >
                            {t("delete")}
                        </ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    );
}